import { ReactNode, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { fetchSession } from '../lib/session';

type Props = { children: ReactNode; roles?: string[]; permissions?: string[] };

export default function ProtectedRoute({ children, roles, permissions }: Props) {
  const [allowed, setAllowed] = useState<boolean | null>(null);
  const roleKey = (roles ?? []).join(',');
  const permissionKey = (permissions ?? []).join(',');

  useEffect(() => {
    (async () => {
      const session = await fetchSession();
      if (!session) {
        setAllowed(false);
        return;
      }
      const requiredRoles = roleKey.length > 0 ? roleKey.split(',') : [];
      const requiredPermissions = permissionKey.length > 0 ? permissionKey.split(',') : [];
      const roleOk = requiredRoles.length === 0 || requiredRoles.some((role) => session.roles.includes(role));
      const permissionOk = requiredPermissions.length === 0
        || requiredPermissions.some((permission) => session.permissions.includes(permission));
      setAllowed(roleOk && permissionOk);
    })();
  }, [roleKey, permissionKey]);

  if (allowed === null) return <div className="p-4 text-center text-sm text-muted-foreground">Loading...</div>;
  return allowed ? <>{children}</> : <Navigate to="/" replace />;
}
